import { createAsyncThunk } from '@reduxjs/toolkit';
import { baseUrl } from '../../../constants/Endpoints/EndPoints';
import { FetchRequestHandler } from '../../../utils/commonUtilities';

export const fetchOfficeHours = createAsyncThunk(
    'fetchOfficeHours', 
    async (practiceId) => {
        const response = await FetchRequestHandler(
            'get', 
            `${baseUrl}api/practices/${practiceId}/office-hours`
        );
        return response.data;
    }
);

export const fetchUpdateOfficeHours = createAsyncThunk(
    'fetchUpdateOfficeHours',
    async ({ practiceId, data }) => {
        const response = await FetchRequestHandler(
            'put', 
            `${baseUrl}api/practices/${practiceId}/office-hours`, 
            data
        );
        return response.data;
    }
);